import { render } from "./TariffSelector.vue?vue&type=template&id=47e9369f&scoped=true"
import script from "./TariffSelector.vue?vue&type=script&lang=js"
export * from "./TariffSelector.vue?vue&type=script&lang=js"

import "./TariffSelector.vue?vue&type=style&index=0&id=47e9369f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e9369f"]])

export default __exports__